// extracted by css-extract-rspack-plugin
export default {"prompt":"_dbef2128","button":"_537b84fa"};